module.exports = __webpack_public_path__ + "8b3effc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/static/bannerDefault.jpg
// module id = 1007
// module chunks = 1 2